import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function evaluationSampleList(
  accountId: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${accountId}/evaluation/sample/list${queryString}`,
  );
}

export async function evaluationSampleShow(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.get(
    `account/${account_id}/evaluation/sample/${item_id}/show`,
  );
}

export async function evaluationSampleCreate(
  account_id: string,
  payload: {
    evaluation_id: string;
    sample_id: string;
  },
) {
  return await clientAxios.post(
    `account/${account_id}/evaluation/sample/create`,
    payload,
  );
}

export async function evaluationSampleDelete(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/evaluation/sample/${item_id}/delete`,
  );
}

export async function evaluationEmployeeSampleUpload(
  account_id: string,
  item_id: string,
) {
  //   return await clientAxios.del(
  //     `account/${account_id}/evaluation/sample/${item_id}/delete`,
  //   );
}
